import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import RenderSelectBoxCell from "../../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    StateStoring
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox, TextArea } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import data from "../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
let status = "";
const PalletTrackingTab = (props) => {
    const dataGrid = useRef(null);
    const gridKey = "56213c6c-155b-4fe1-874d-eca0cf732cfd";
    const isFormLoadRef = useRef(true);
    var url = "wm/PalletTracking/GetPalletTrackingDetails";
    var updateUrl = "wm/PalletTracking/UpdatePalletTrackingDetails";
    var insertUrl = "wm/PalletTracking/AddPalletTrackingDetails";
    var deleteUrl = "wm/PalletTracking/DeletePalletTrackingDetail";
    const dataSource = createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        deleteUrl: `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.headerId,
                "type": props.formFields.TRANSACTIONTYPE,
                "transdate": props.formFields.TRANSACTIONDATE,
                "FormLoad": isFormLoadRef.current,
            };
        }
        ,
        onUpdated: function (e) {
            isFormLoadRef.current = false;
        },
        onInserted: function (e) {
            isFormLoadRef.current = false;
        }

    });
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    async function setStateValue3(rowData, value) {

        try {
            rowData.status = status;
            rowData.statuscode = value;
        } catch (error) {
            console.error("Failed to fetch item data:", error);
        }
    }
    const renderStatusCell = (cellElement) => {
        const items = [{ "id": "H", "name": "Hold" },
        { "id": "O", "name": "Open" },
        ];
        const currentValue = cellElement.row.data.statuscode;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={false}
                searchMode="contains"
                showClearButton={false}
                searchExpr="name"
                onValueChanged={(e) => {
                    const selectedText = e.component.option('displayValue');
                    status = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const deleteRecords = useCallback(() => {
        var deleteUrl = "wm/PalletTracking/DeletePalletTrackingDetail";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                        props.UpdateTotalAmount();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                    });

            }
        });

    }, [selectedItemKeys]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const onRowInserted = (e) => {
        var tdate = GetFormatedDateWithTime(new Date());
        if (!e.data.transactionDate) {
            e.data.transactionDate = tdate;
        }
        if (!e.data.status) {
            e.data.status = "O";
            e.data.statuscode = "Open";
        }
    };
    const renderCode1Cell = (cellElement) => {
        return (
            <TextArea
                onValueChanged={async (e) => {
                    cellElement.setValue(e.value);
                }}
                label="."
                labelMode='static'
                stylingMode='outlined'

            >
            </TextArea>
        );
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onInitNewRow={onRowInserted}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="multiple" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="owner" caption="Owner ID" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetOwners`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.ownerid,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.ownerid = newValue.value;
                        rowData.owner = newValue.text;
                    }}
                >
                </Column>
                <Column dataField="behalfoffrom" caption="From Account Of" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetPatrons`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.behalfoffromid,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.behalfoffromid = newValue.value;
                        rowData.behalfoffrom = newValue.text;
                    }}
                >
                </Column>
                <Column dataField="behalfofto" caption="To Account Of" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetPatrons`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.behalfoftoid,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.behalfoftoid = newValue.value;
                        rowData.behalfofto = newValue.text;
                    }}
                >
                </Column>
                <Column dataField="transactionDate" dataType="datetime" caption="Transaction Date" allowSorting={false} ></Column>
                <Column dataField="palletsIn" caption='Pallets In' dataType="number" format="#,##0.00" allowSorting={false} />
                <Column dataField="palletsOut" caption='Pallets Out' dataType="number" format="#,##0.00" allowSorting={false} />
                <Column dataField="netQuantity" caption='Net Quantity' dataType="number" allowSorting={false} format="#,##0.00" />
                <Column dataField="reference" caption='Reference' allowSorting={false} />
                <Column visible={false} dataField="userDefinedCode1" caption="Code-1" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                            loadParams: {
                                codeType: function () {
                                    return 'YA';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode1,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode1 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userDefinedCode2" caption="Code-2" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                            loadParams: {
                                codeType: function () {
                                    return 'YB';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode2,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode2 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userDefinedCode3" caption="Code-3" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                            loadParams: {
                                codeType: function () {
                                    return 'YC';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode3,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode3 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userDefinedCode4" caption="Code-4" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                            loadParams: {
                                codeType: function () {
                                    return 'YD';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode4,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode4 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userDefinedCode5" caption="Code-5" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                            loadParams: {
                                codeType: function () {
                                    return 'YE';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode5,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode5 = newValue.text;
                    }}
                />
                <Column dataField="userDefinedReference1" allowSorting={false} caption='Reference- 1' visible={false} editorOptions={{ maxLength: 50 }} />
                <Column dataField="userDefinedReference2" allowSorting={false} caption='Reference- 2' visible={false} editorOptions={{ maxLength: 50 }} />
                <Column dataField="userDefinedReference3" allowSorting={false} caption='Reference- 3' visible={false} editorOptions={{ maxLength: 50 }} />
                <Column dataField="userDefinedReference4" allowSorting={false} caption='Reference- 4' visible={false} editorOptions={{ maxLength: 50 }} />
                <Column dataField="userDefinedReference5" allowSorting={false} caption='Reference- 5' visible={false} editorOptions={{ maxLength: 50 }} />
                <Column dataField="comment" visible={false} allowSorting={false} editCellRender={renderCode1Cell}
                    setCellValue={(rowData, newValue) => {
                        rowData.comment = newValue;
                    }} caption='Comment' >
                </Column>
                <Column dataField="statuscode" caption='Status' allowSorting={false} visible={false} editCellRender={renderStatusCell} setCellValue={setStateValue3}  >
                </Column>
                <Toolbar>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(PalletTrackingTab);